export default __webpack_public_path__ + "static/CentraNo2-Light-7bc9339b34ffe3e94d97305507d749cf.woff2";